import React from 'react';

import Select, {Creatable} from 'react-select';

import { strings } from 'APP_ROOT/localization';
import LambdaUtil from 'APP_ROOT/components/aws/lambda/lambdaUtil';
import SimpleProfileImage from 'APP_ROOT/components/SimpleProfileImage';
import ProgressOverlay from '../../../components/common/ProgressOverlay';

export default class DriverList extends React.PureComponent {

    state = {
        getOptionsInProgress: false,
        updateInProgress: false,
        options: '',
        selectedOption: null,
        editing: false,
        errorMessage: '',
    }

    componentDidMount() {
        this.updateScrollButtons();
        window.addEventListener('resize', this.updateScrollButtons);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateScrollButtons);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.editing === true && this.state.editing === false) {
            this.updateScrollButtons();
            if(this.state.currentScrollPosition) {
                const driverOccupantsList = document.querySelector('.driver-occupants-list');
                if (driverOccupantsList) {
                    driverOccupantsList.scrollLeft = this.state.currentScrollPosition;
                }
            }
        }
    }

    getOptions = () => {
        const { getOptionsInProgress } = this.state;
        if (getOptionsInProgress) {
            console.log("ignoring redundant getFaces call");
            return;
        }
        this.setState({
            getOptionsInProgress: true
        });
        LambdaUtil.getNamedIdentities(this.props.stage)
            .then((payload) => {
                const { knownIdentities } = payload.listIdentities;
                if (!knownIdentities) return [];
                return knownIdentities.map((identity, index) => (
                    {
                        image: identity.profileFace ? identity.profileFace.secureImageUrl : '/images/ic_person_48px.svg',
                        ...identity
                    }
                ));
            }).then(knownIdentities => knownIdentities.sort(function(a, b){
                if(a.name < b.name) return -1;
                if(a.name > b.name) return 1;
                return 0;
            }).map(it => (
                {
                    label: it.name,
                    value: it
                }
            ))).then(options => {
                return {
                    options
                };
            }).then(result => {
                this.setState({
                    ...result,
                    getOptionsInProgress: false
                });
            })
            .catch(err => {
                console.log(err);
                this.setState({
                    errorMessage: strings.formatString(strings.app_an_error_occurred),
                    getOptionsInProgress: false
                });
            });
    }

    handleEditClick = (driver) => {        
        this.getOptions();
        this.setState({
            editing: true,
            selectedOption: {
                label: driver.name,
                value: driver
            }
        });

        const driverOccupantsList = document.querySelector('.driver-occupants-list');

        if (driverOccupantsList) {
            this.setState({
                currentScrollPosition: driverOccupantsList.scrollLeft
            });
        }
    }

    getfilteredDrivers = () => {
        const { drivers } = this.props;
        const driverIdHash = {};
        const filteredDrivers = drivers && drivers.length ? drivers.filter(d => {
            if (!driverIdHash[d.identityId]) {
                driverIdHash[d.identityId] = true;
                return true;
            }
            return false;
        }) : undefined;

        return filteredDrivers;
    }

    handleOnChange = (option) => {

        if(!option || !option.value) {
            this.setState({
                editing: false,
                selectedOption: null
            });
            return;
        }

        this.setState({
            updateInProgress: true,
        });

        if(typeof option.value === 'string') {
            const filteredDrivers = this.getfilteredDrivers();
            const { selectedOption } = this.state;
            
            if (selectedOption &&
                Array.isArray(filteredDrivers) &&
                filteredDrivers.find(d => d.identityId === selectedOption.value.identityId)) {

                this.props.setDriverName(selectedOption.value.identityId, option.value)
                    .catch(err => {
                        console.error('DriverList.handleOnChange: Error updating driver name', option, selectedOption, err);
                    })
                    .finally(() => {
                        this.setState({
                            updateInProgress: false,
                        });
                    });
            }
        }
        else {
            this.props.assignDriver(option.value.identityId)
                    .catch(err => {
                        console.error('DriverList.handleOnChange: Error updating driver', option, err);
                    })
                    .finally(() => {
                        this.setState({
                            updateInProgress: false,
                        });
                    });
        }

        this.setState({
            editing: false,
            selectedOption: null
        });
    }

    handleOnClose = () => {
        this.setState({ 
            editing: false,
            selectedOption: null
        });
    }

    scrollTo = (direction) => {
        const driverOccupantsList = document.querySelector('.driver-occupants-list');
        if( driverOccupantsList ) {
            driverOccupantsList.scrollBy({
                left: direction === 'left' ? -100 : 100, // width of one driver item
                behavior: 'smooth'
            });
        }
    }

    scrollLeft = () => {
        this.scrollTo('left');
    }

    scrollRight = () => {
        this.scrollTo('right');
    }

    updateScrollButtons = () => {
        const container = document.querySelector('.driver-occupants-list');
        const btnLeft = container.previousElementSibling; // left button
        const btnRight = container.nextElementSibling; // right button
        if (!container || !btnLeft || !btnRight) return; // Ensure buttons exist

        const scrollLeft = container.scrollLeft;
        const scrollWidth = container.scrollWidth;
        const clientWidth = container.clientWidth;

        // Hide both if no overflow
        if (scrollWidth <= clientWidth) {
            btnLeft.classList.add('hidden');
            btnRight.classList.add('hidden');
        } else {
            btnLeft.classList.toggle('hidden', scrollLeft <= 0);
            btnRight.classList.toggle('hidden', scrollLeft + clientWidth >= scrollWidth - 1); // slight buffer
        }
    }

    render() {
        const { allowEdit } = this.props;
        const { editing, options, selectedOption } = this.state;
        const filteredDrivers = this.getfilteredDrivers() || [ { name: strings.unknown_driver } ];

        if(editing) {
            return (<DriverSelect selectedOption={selectedOption} options={options} onChange={this.handleOnChange} onClose={this.handleOnClose} />);
        } else {
            return (
                <div className="driver-occupants-info">
                    <button type="button" className="scroll-btn left" onClick={this.scrollLeft}><i className='material-icons'>chevron_left</i></button>
                    <div className="driver-occupants-list" onScroll={this.updateScrollButtons}>
                        {filteredDrivers.map(driver => <DriverItem key={driver.name} driver={driver} allowEdit={allowEdit} handleEditClick={this.handleEditClick} />)}
                    </div>
                    <button type="button" className="scroll-btn right" onClick={this.scrollRight}><i className='material-icons'>chevron_right</i></button>

                    {this.state.updateInProgress && <ProgressOverlay />}
                </div>
            );
        }
    }

}

const DriverItem = ({ driver, option, allowEdit, handleEditClick }) => {
    const driverName = option?.label ? option.label : driver?.name ?? strings.unknown_driver;
    return (<div className='driver-occupant-info'>
        <SimpleProfileImage.Small width={32} src={option?.value?.image ?? driver?.image} />
        <div className="drivername" title={driverName}>{driverName}</div>
        {allowEdit &&
            <div className='driver-occupant-info-actions'>
                <button
                    type="button"
                    className="btn btn-outline-blue btn-sm"
                    onClick={() => handleEditClick(driver)}
                    style={{minWidth:'auto'}}
                >
                    <i className="material-icons">edit</i>
                </button>
            </div>
        }
    </div>);
}

const renderOption = (option, driver) => {
    return <DriverItem driver={driver} option={option} />
}

const DriverSelect = (selectProps) => {
    const {selectedOption} = selectProps;
    const selectedDriver = selectedOption.value;
    const canEditName = !selectedDriver.name;

    return canEditName ? (
        <Creatable
            className="driver-occupants-info editing-driver"
            autoFocus={true}
            placeholder={strings.new_faces_name_prompt_text_creator}
            noResultsText={strings.new_faces_no_preexisting_names}
            promptTextCreator={ label => strings.new_faces_name_prompt_text_creator + label }
            optionRenderer={(option) => renderOption(option, selectedDriver)}
            {...selectProps}
        />
    ) : (
        <Select
            className="driver-occupants-info editing-driver"
            autoFocus={true}
            placeholder={strings.action_select_driver}
            noResultsText={strings.new_faces_no_preexisting_names}
            valueRenderer={renderOption}
            optionRenderer={renderOption}
            {...selectProps}
        />
    )
};
